// extracted by mini-css-extract-plugin
module.exports = {"section":"C_section__JdhC6","ani-fade-in-opacity":"C_ani-fade-in-opacity__l4FkU","ani-fade-in-width":"C_ani-fade-in-width__pcEXy"};